import currencyFormatService from 'commons/currency/service/currencyFormatService';

export default (value, currency, decimals) =>
  currencyFormatService.formatValue(value, currency, decimals);
